import React from "react";
import { Link } from "react-router";

function Tools({
  count,
  deleteClientUrls,
}) {
  return (
    <div className="admin_list">
      <h5>
        Client urls(<span>{count}</span>)
      </h5>
      <Link className="button_classic" to="/client-url/new">
        Add Client Url
      </Link>
      <a className="button_delete" onClick={deleteClientUrls}>
        Delete
      </a>
    </div>
  );
}

Tools.defaultProps = {};

Tools.propTypes = {};

export default Tools;



// WEBPACK FOOTER //
// ./src/components/Admin/ClientUrls/Toolbar/Tools.jsx